// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  appVersion: "1.6.1004",
  firebase: {
    apiKey: "AIzaSyBea1uEghMR2ZZShoKBxDpgXgQs0_W-h6U",
    authDomain: "sipass.firebaseapp.com",
    databaseURL: "https://sipass.firebaseio.com",
    projectId: "sipass",
    storageBucket: "sipass.appspot.com",
    messagingSenderId: "212959011845",
    appId: "1:212959011845:web:50a13b5a9894d1f3c7e86c",
    measurementId: "G-VDZFK1P5LL",
  },
  googleMaps: {
    location: {
      apiKey: "AIzaSyBea1uEghMR2ZZShoKBxDpgXgQs0_W-h6U",
    },
    address: {
      apiKey: "AIzaSyBzmIsWQDpfrfzUU6jCIXIuxKntVYJJzbs",
    },
  },
  stripe: {
    api: "https://us-central1-sipass.cloudfunctions.net/apiV2a/stripe/",
    apiKeyTest:
      "pk_test_51Iv6WFEoMQ5xqqPsyPYv5TmUBKscIjU8jZeBPItccJG1c5U7kYf8tlfVC2vITEkDI3mnZDZWoR6L7J8lJBxsizZr00o89CZQwK",
    apiKey:
      "pk_live_51Iv6WFEoMQ5xqqPsBhcUjZG5zZH8AVcuiUlmTthaEsYtQ2I6nrRXkO4QXONy6CDQfv5CWUAG2h8wvCIqlq5shPnX00npFskZSK",
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
